import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { TogglesValidation } from "../../core/helpers/toggles";
import { TogglesConfiguration } from "../../core/enum/toggles-configuration.enum";
import { LocalStorage } from "src/app/core/helpers/local-storage";

@Injectable()
export class UrlInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith("/")) {
      const hasToggleSelectApi = TogglesValidation.toggleShow(TogglesConfiguration.SELECT_API_AT_LOGIN);
      const apiUrl = hasToggleSelectApi ? LocalStorage.getItem("apiManualByLogin") || environment.apiUrl : environment.apiUrl;
      return next.handle(
        request.clone({
          url: `${apiUrl}${request.url}`
        })
      );
    }

    return next.handle(request);
  }
}
